/**
 * PURPOSE: Centralizar las solicitudes HTTP del sorteo de países del evento 17.
 * RESPONSIBILITIES: Consultar, guardar y restaurar las asignaciones de países.
 * COLLABORATORS: SorteoArea2.jsx y backend routes/InstitutionsRoute.js.
 * ROUTE: frontend/src/services/event17CountryDraw.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const ENDPOINT = `${API_BASE_URL}/event17-country-draw`;

export const getEvent17CountryDraw = async () => {
  const { data } = await axios.get(ENDPOINT);
  return data;
};

export const updateEvent17CountryDraw = async (assignments) => {
  const { data } = await axios.patch(ENDPOINT, { assignments });
  return data;
};

export const resetEvent17CountryDraw = async () => {
  const { data } = await axios.patch(`${ENDPOINT}/reset`);
  return data;
};
